var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasurePerf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21.5V6.77558L13.5 1.09137L22.5 6.77558V21.5H4.5Z",
    stroke: "#CCCCCC",
    fill: "#363d4f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6582 7.48499L20.722 10.2215L19.9827 9.47037L15.9725 13.418L15.8045 13.5834L15.6365 13.4181L12.0252 9.86606L6.50654 15.2855L6.33564 15.4533L6 15.1115L6.1709 14.9437L11.8576 9.35935L12.0255 9.19442L12.1934 9.35949L15.8044 12.9113L19.6466 9.12901L18.9073 8.37797L21.6582 7.48499Z",
    fill: "#8E8E98"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33789 15.1146L12.0246 9.53025L15.8037 13.2473L20.0627 9.04947",
    stroke: "#8E8E98",
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 17.2994L8.96407 15.3832V20.2695H7V17.2994Z",
    fill: "#8E8E98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1621 13.9461L20.1262 11.9341V20.2695H18.1621V13.9461Z",
    fill: "#8E8E98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4844 17.3473L14.5203 15.3353V20.2695H16.4844V17.3473Z",
    fill: "#8E8E98"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6307 13.6362L11.766 12.7485L10.784 13.7488V20.2818H12.748L12.6307 13.6362Z",
    fill: "#8E8E98"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6061 7.73618L14.2861 0.185458C13.8395 -0.0618194 13.1605 -0.0618194 12.7139 0.185458L0.393896 7.73618C0.079503 7.90849 -0.0611723 8.1706 0.0248612 8.4238C0.110895 8.67699 0.410566 8.88279 0.810993 8.96367C1.21142 9.04456 1.65177 8.98824 1.96616 8.81594L13.5 1.68992L25.0338 8.80154C25.3482 8.97384 25.7886 9.03016 26.189 8.94928C26.5894 8.86839 26.8891 8.66259 26.9751 8.4094C27.0612 8.15621 26.9205 7.89409 26.6061 7.72178V7.73618Z",
    fill: "#CCCCCC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurePerf);
export default __webpack_public_path__ + "static/media/MeasurePerf.520331878300018b0371923713e227c3.svg";
export { ForwardRef as ReactComponent };